
define('text!fusion/ui/controls/fusion-datatable.html',[],function () { return '<div class="fusion-datatable">\r\n\r\n    <label data-part="validationMessage_PART"></label>\r\n\r\n    <table data-bind="attr:{id: instanceId}" class="display"></table>\r\n\r\n</div>\r\n';});

